export default __webpack_public_path__ + "static/media/unicorn.0ce40444.png";